// React
import { ReactElement } from 'react';
// Design System
import { Font } from '@utmb/design-system/text/font';
// Types
import { RadioProps } from '@utmb/types/form';
// Styles
import styles from '../checkbox/checkbox.module.scss';

export const Radio = (props: RadioProps): ReactElement => {
    const { id, name, value, onChange, onBlur, label, className = undefined, isChecked = false } = props;

    return (
        <div className={styles.container}>
            <div className={styles.input_container}>
                <input id={id} type="radio" name={name} value={value} className={className} onChange={onChange} onBlur={onBlur} defaultChecked={isChecked} />
                <div className={styles.input_element}></div>
            </div>

            {label && (
                <Font.FuturaBook as="span" mobile="22" desktop="22" className={styles.label}>
                    <label htmlFor={id}>{label}</label>
                </Font.FuturaBook>
            )}
        </div>
    );
};
